import { UsersContainer } from 'modules/Users'
import React from 'react'

type Props = {}

const Users = (props: Props) => {
  return (
    <UsersContainer />
  )
}

export default Users